/**
 * ccg-product-form.js
 * --------------------
 * Alpine.data('productForm') — Product 詳細ページの variant 選択 + cart form 制御
 *
 * 使い方 (main-product.liquid):
 *   <section x-data="productForm(initialVariant, variants, options)" x-init="init()">
 *     ...
 *     <form action="/cart/add" method="post">
 *       <input type="hidden" name="id" :value="currentVariant ? currentVariant.id : ''">
 *       <select name="options[サイズ]">...</select>
 *       <select name="options[カラー]">...</select>
 *       <button type="submit" :disabled="!currentVariant || !currentVariant.available">カートに追加</button>
 *     </form>
 *   </section>
 *
 * - select[name="options[...]"] の change を監視して、該当する variant を探し currentVariant に反映
 * - hidden input name="id" は :value バインディングで自動更新 (Alpine reactive)
 * - 在庫切れ variant の場合 currentVariant.available = false、ボタン disabled
 */
document.addEventListener('alpine:init', () => {
  Alpine.data('productForm', (initialVariant, variants, options) => ({
    variants: variants || [],
    options: options || [],
    currentVariant: initialVariant || null,
    selectedOptions: initialVariant && initialVariant.options ? [...initialVariant.options] : [],

    init() {
      // 初期 currentVariant を確実に同期
      this.updateCurrentVariant();
    },

    /**
     * option_index 番目の option を value に変更
     * (hidden select の @change="selectOption(...)" から呼ばれる)
     */
    selectOption(optionIndex, value) {
      this.selectedOptions[optionIndex] = value;
      this.updateCurrentVariant();
    },

    updateCurrentVariant() {
      const found = this.variants.find((v) =>
        Array.isArray(v.options) && v.options.every((opt, i) => opt === this.selectedOptions[i])
      );
      this.currentVariant = found || null;
    },

    /**
     * カート追加: form submit ハンドラ (@submit.prevent から呼ばれる)
     * - currentVariant が無い / 在庫切れなら何もしない
     * - 通常の form POST で /cart/add に送信し、/cart に遷移
     */
    addToCart(event) {
      if (!this.currentVariant || !this.currentVariant.available) {
        return;
      }
      // hidden id input が currentVariant.id で更新済みの状態で submit
      // @submit.prevent で event.preventDefault が走っているので、ここで明示的に submit() 呼び出し
      const form = event.target.closest('form') || event.target;
      if (form && typeof form.submit === 'function') {
        form.submit();
      }
    },
  }));
});
